import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import { IChangeStatusCommands, IMultiEnabled } from '../../interfaces';
import { subscribersFeaturesDict, upperCaseFirstLetter } from '../../instruments';
import { ITrButton, ITrText, tT } from '../../translate';
import { Catcher } from '../Catcher';
import Styles from '../styles/m_itemCardStyles.less';

export const featuresSelectCommandTitles: { [command: string]: ITrButton } = {
    activate: 'Activate',
    block: 'Suspend',
    unblock: 'Resume',
};

export const featuresSelectCommands = Object.keys(featuresSelectCommandTitles) as IChangeStatusCommands[];

export const isFeaturesSelectCommand = (command?: IChangeStatusCommands): boolean =>
    !!command && featuresSelectCommands.includes(command);

export const getFeaturesPayload = (command: IChangeStatusCommands, selectedFeatures: string[]): IMultiEnabled =>
    subscribersFeaturesDict.reduce((acc: IMultiEnabled, feature: string) => {
        const isSelected = selectedFeatures.includes(feature);

        return { ...acc, [feature]: { enabled: command === 'block' ? !isSelected : isSelected } };
    }, {});

export const isFeaturesDriveNeeded = (command: IChangeStatusCommands, selectedFeatures: string[]): boolean =>
    command === 'block' ? selectedFeatures.length === subscribersFeaturesDict.length : !!selectedFeatures.length;

type ISubscribersFeaturesSelect = {
    children?: never;
    command?: IChangeStatusCommands;
    isLoading?: boolean;
    onChange: (selectedFeatures: string[]) => void;
    value: string[];
};

export const SubscribersFeaturesSelect: React.FC<ISubscribersFeaturesSelect> = ({
    command,
    isLoading,
    onChange,
    value,
}: ISubscribersFeaturesSelect) => {
    const selectHintKey: ITrText =
        command === 'block'
            ? 'Select the features to disable. Unselected features are enabled.'
            : 'Select the features to enable. Unselected features are disabled.';

    return (
        <Catcher>
            <div className={Styles.featuresSelect}>
                <p className={Styles.featuresSelectHint}>{tT(selectHintKey)}</p>
                <Checkbox.Group
                    disabled={isLoading}
                    onChange={(values: CheckboxValueType[]): void => onChange(values as string[])}
                    options={subscribersFeaturesDict.map((feature: string) => ({
                        label: upperCaseFirstLetter(feature),
                        value: feature,
                    }))}
                    value={value}
                />
            </div>
        </Catcher>
    );
};
